import { FC } from 'react'
import { useQueryParams, useQueryParamsState } from 'src/hooks/ui'
import { useBleConnectionLogListRequest } from 'src/hooks/api'
import { BleConnectionLogList } from './bleConnectionLogList'

const defaultPerPage = 25
const defaultPage = 1
const initialQueryParams = {
  page: `${defaultPage}`,
  rowsPerPage: `${defaultPerPage}`
}

export const BleConnectionLogsSection: FC = () => {
  const params = useQueryParamsState()
  const { data, isInitialLoading } = useBleConnectionLogListRequest({ params })
  const [queryParams, setQueryParams] = useQueryParams(initialQueryParams)

  return (
    <BleConnectionLogList
      logs={data?.rows || []}
      logCount={data?.count || 0}
      isLoading={isInitialLoading}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
      showFilters={true}
    />
  )
}
